import { get, set, del } from "idb-keyval";
import {
	PersistedClient,
	Persister
} from "@tanstack/react-query-persist-client";

const logError = (error: any): void => console.error(error);

export function createIDBPersister(
	idbValidKey: IDBValidKey = "REACT_QUERY_OFFLINE_CACHE"
) {
	return {
		persistClient: async (client: PersistedClient): Promise<void> => {
			/*
				Descendant objects of a PersistedClient may occasionally contain
				functions, which cannot be serialized by the structured clone algorithm
				used by the IndexedDB, and will throw an error when calling set().

				See: https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm#things_that_dont_work_with_structured_clone

				Therefore we follow the example of react-query's default persisters for
				the time being and sanitize PersistedClient by converting it to a JSON
				string and back to silently remove unsupported data types.
				
				See: https://github.com/TanStack/query/blob/34657e5a12f53b265e53e101033b3416cd455e28/packages/query-async-storage-persister/src/index.ts#L42
				
				In the future if we want to take advantage of IndexedDB's benefits over
				local storage, we should find a better way to sanitize the
				PersistedClient object.
			*/
			client = JSON.parse(JSON.stringify(client));
			return await set(idbValidKey, client).catch(logError);
		},
		restoreClient: async (): Promise<PersistedClient | undefined> => {
			return await get<PersistedClient>(idbValidKey).catch((error) => {
				logError(error);
				return undefined;
			});
		},
		removeClient: async (): Promise<void> => {
			return await del(idbValidKey).catch(logError);
		}
	} as Persister;
}
